import { employeeServiceApi } from "../../app/employeeServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType, PatchQueryArgsType } from "../../types";
import {
  GetExpenseUnitDetailsResponseType,
  GetExpenseUnitsParams,
  GetExpenseUnitsResponseType,
} from "../../types/expenseUnit";

export const expenseUnitApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseUnits: builder.query<
      GetExpenseUnitsResponseType,
      GetQueryArgsType<GetExpenseUnitsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getExpenseUnits,
        ...queryArgs,
      }),
      providesTags: ["GetExpenseUnits"],
    }),
    getExpenseUnitDetails: builder.query<
      GetExpenseUnitDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getExpenseUnitDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetExpenseUnitDetails",
          id,
        },
      ],
    }),
    addExpenseUnit: builder.mutation({
      query: (data) => ({
        url: API_URL.addExpenseUnit,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetExpenseUnits"];
        return [];
      },
    }),
    updateExpenseUnit: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateExpenseUnit}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetExpenseUnits",
            {
              type: "GetExpenseUnitDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateExpenseUnitStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateExpenseUnitStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetExpenseUnits",
            {
              type: "GetExpenseUnitDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetExpenseUnitsQuery,
  useGetExpenseUnitDetailsQuery,
  useAddExpenseUnitMutation,
  useUpdateExpenseUnitMutation,
  useUpdateExpenseUnitStatusMutation,
} = expenseUnitApi;
